import { createReducer, on } from '@ngrx/store';
import { ELoadStatus } from '../state.interface';
import { ISlideshowContentState } from './slideshow-content-store.interface';
import { slideshowContentActions } from './slideshow-content.actions';

export const initialState: ISlideshowContentState = {
  slideshowData: null,
  slideshowDataLoadStatus: ELoadStatus.initial,
};

export const slideshowContentReducer = createReducer(
  initialState,
  on(
    slideshowContentActions.fetchSlideshowContents,
    (state): ISlideshowContentState => ({ ...state, slideshowDataLoadStatus: ELoadStatus.loading }),
  ),
  on(
    slideshowContentActions.fetchSlideshowContentsCompleted,
    (state, action): ISlideshowContentState => ({
      ...state,
      slideshowData: action.slideshow,
      slideshowDataLoadStatus: ELoadStatus.success,
    }),
  ),
);
